import React, { useEffect, useState } from 'react';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import './SearchInput.scss';

export interface SearchInputProps {
  onSearch: (query: string) => void;
  delay?: number;
  placeholder?: string;
  className?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

const SearchInput: React.FC<SearchInputProps> = ({
  onSearch,
  delay = 300,
  placeholder = 'Search...',
  className = '',
  inputRef,
}) => {
  const [inputValue, setInputValue] = useState('');
  const [debouncedValue, setDebouncedValue] = useState('');

  useEffect(() => {
    const handler = window.setTimeout(() => {
      setDebouncedValue(inputValue);
    }, delay);

    return () => window.clearTimeout(handler);
  }, [inputValue, delay]);

  useEffect(() => {
    onSearch(debouncedValue.trim());
  }, [debouncedValue, onSearch]);

  const handleClear = () => {
    setInputValue('');
    setDebouncedValue('');
    onSearch('');
  };

  return (
    <div className={`search-input ${className}`.trim()}>
      <SearchIcon className="search-input__icon" aria-hidden="true" />
      <input
        ref={inputRef}
        className="search-input__field"
        type="search"
        value={inputValue}
        placeholder={placeholder}
        onChange={(e) => setInputValue(e.target.value)}
        aria-label={placeholder}
      />
      {inputValue && (
        <IconButton
          size="small"
          className="search-input__clear"
          onClick={handleClear}
          aria-label="Clear search"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

export default React.memo(SearchInput);
